const RESOURCE_SERVER_CLIENT_ID = "2b2823e3-1c28-4bc5-bc81-f993a591d5ef";
const BACKEND_BASE_URL = 'https://bsa-api-dev.musea2.azure.ext.gm.com';
const BACKEND_API_SCOPE = `api://bsa-api-access-auth.pp.gm.com/user_impersonation`;

export const environment = {
  production: false,
  backend_base_url: BACKEND_BASE_URL,
  redirectUri: 'https://bsa-frontend-dev.musea2.azure.ext.gm.com/',
  API_URL: "https://ps-api-dev.musea2.azure.ext.gm.com",
  CLIENT_ID: "8bc6916c-41e3-4ae3-ade8-3297ea4a5c5f",
  AUTHORITY: "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
  msal: {
    clientId: "8bc6916c-41e3-4ae3-ade8-3297ea4a5c5f",
    authority: "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
    backendApiScope: BACKEND_API_SCOPE,
    protectedResourceMap: new Map([
      ["https://graph.microsoft.com/v1.0/me", ["User.Read", "User.Read.All"]],
      ["https://graph.microsoft.com/v1.0/users", ["User.Read", "User.Read.All"]],
      ["https://graph.microsoft.com/v1.0/users/broadcasting_services@pp.gm.com/sendmail", ["Mail.Send"]],
      [`${BACKEND_BASE_URL}/api`, [BACKEND_API_SCOPE]],
    ])
  }
};